import * as actions from "./actionsTypes";

const initialData = {
  loaderEvalFormFactor: false,
  evalFormFactor: null,
  evalFormFactorState: false,
  nota: 0,
  desempeño: "",
  evalFormFactorFalla: null,
  saveLoaderEvalFormFactor: false,
  evalFormFactorFormError:null,
};

export default function EvalFormFactorReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_FORMULARIO_FACTOR:
      return { ...state, loaderEvalFormFactor: action.payload };

    case actions.GET_FORMULARIO_FACTOR:
      return {
        ...state,
        evalFormFactor: action.payload.evalFormFactor,
        evalFormFactorState: action.payload.evalFormFactorState,
        nota: action.payload.nota,
        desempeño: action.payload.desempeño
      };

    case actions.FORMULARIO_FACTOR_FALLA:
      return { ...state, evalFormFactorFalla: action.payload };

    case actions.SAVE_LOADER_FORMULARIO_FACTOR:
      return { ...state, saveLoaderEvalFormFactor: action.payload };

    case actions.FORM_FORMULARIO_FACTOR_FAIL:
      return { ...state, evalFormFactorFormError: action.payload };
    default:
      return state;
  }
}
